import ApiConstant from "../../constants/api.constants";
import api from "../api";

export interface OpenCourierOrderRowDTO {
    orderID: number;
    orderDate: string;
    grossAmount: number;
    productCount: number;
    customerName: string | null;
    customerMobile: string | null;
    createdByName: string | null;
    createdByMobile: string | null;
    courierProviderName: string | null;
}

export interface OpenCourierOrdersReportResponse {
    totalRecords: number;
    orders: OpenCourierOrderRowDTO[];
}

export interface ClosedCourierOrderRowDTO {
    orderID: number;
    orderDate: string;
    orderValue: number;
    customerName: string | null;
    customerMobile: string | null;
    createdByName: string | null;
    createdByMobile: string | null;
    courierProviderName: string | null;
    invoiceNo: number;
    trackingNumber: string | null;
    invoiceDate: string;
    invoiceValue: number;
}

export interface ClosedCourierOrdersReportResponse {
    totalRecords: number;
    invoices: ClosedCourierOrderRowDTO[];
}

const getOpenCourierOrdersReport = async (filter: {
    fromDate?: Date | null;
    toDate?: Date | null;
    keyword?: string;
    courierProviderID?: number | null;
    userID?: number | null;
    minDays?: number;
    maxDays?: number;
    sortField?: string;
    sortOrder?: number;
    pageNumber: number;
    pageSize: number;
    customerMobile?: string;
    reportType: 'OPEN' | 'CLOSED';
}): Promise<OpenCourierOrdersReportResponse> => {
    try {
        const formatDate = (d?: Date | null) => {
            if (!d) return null;
            const y = d.getFullYear();
            const m = String(d.getMonth() + 1).padStart(2, '0');
            const day = String(d.getDate()).padStart(2, '0');
            return `${y}-${m}-${day}`;
        };
        const body = {
            fromDate: formatDate(filter.fromDate) ?? null,
            toDate: formatDate(filter.toDate) ?? null,
            keyword: filter.keyword ?? null,
            courierProviderID: filter.courierProviderID ?? null,
            userID: filter.userID ?? null,
            minDays: filter.minDays ?? null,
            maxDays: filter.maxDays ?? null,
            sortField: filter.sortField ?? null,
            sortOrder: filter.sortOrder ?? null,
            pageNumber: filter.pageNumber,
            pageSize: filter.pageSize,
            customerMobile: filter.customerMobile ?? null,
            reportType: filter.reportType,
        };
        const response = await api.post(ApiConstant.getOpenCourierOrdersReport, body)
            .then((result: any) => {
                if (result) {
                    return result.data;
                }
                return null;
            })
            .catch((error: any) => {
                console.error('Error in getOpenCourierOrdersReport:', error);
                throw error;
            });
        return response || { totalRecords: 0, orders: [] };
    } catch (e) {
        console.error('Error in getOpenCourierOrdersReport:', e);
        return { totalRecords: 0, orders: [] };
    }
}

const getClosedCourierOrdersReport = async (filter: {
    fromDate?: Date | null;
    toDate?: Date | null;
    keyword?: string;
    courierProviderID?: number | null;
    userID?: number | null;
    minDays?: number;
    maxDays?: number;
    sortField?: string;
    sortOrder?: number;
    pageNumber: number;
    pageSize: number;
    customerMobile?: string;
    reportType: 'OPEN' | 'CLOSED';
}): Promise<ClosedCourierOrdersReportResponse> => {
    try {
        const formatDate = (d?: Date | null) => {
            if (!d) return null;
            const y = d.getFullYear();
            const m = String(d.getMonth() + 1).padStart(2, '0');
            const day = String(d.getDate()).padStart(2, '0');
            return `${y}-${m}-${day}`;
        };
        const body = {
            fromDate: formatDate(filter.fromDate) ?? null,
            toDate: formatDate(filter.toDate) ?? null,
            keyword: filter.keyword ?? null,
            courierProviderID: filter.courierProviderID ?? null,
            userID: filter.userID ?? null,
            minDays: filter.minDays ?? null,
            maxDays: filter.maxDays ?? null,
            sortField: filter.sortField ?? null,
            sortOrder: filter.sortOrder ?? null,
            pageNumber: filter.pageNumber,
            pageSize: filter.pageSize,
            customerMobile: filter.customerMobile ?? null,
            reportType: filter.reportType,
        };
        const response = await api.post(ApiConstant.getClosedCourierOrdersReport, body)
            .then((result: any) => {
                if (result) {
                    return result.data;
                }
                return null;
            })
            .catch((error: any) => {
                console.error('Error in getClosedCourierOrdersReport:', error);
                throw error;
            });
        return response || { totalRecords: 0, invoices: [] };
    } catch (e) {
        console.error('Error in getClosedCourierOrdersReport:', e);
        return { totalRecords: 0, invoices: [] };
    }
}

const courierOrderService = {
    getOpenCourierOrdersReport,
    getClosedCourierOrdersReport
};

export default courierOrderService;
